
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';

export default function StickyQuoteBar() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Show bar after scrolling 300px
      setIsVisible(window.scrollY > 300);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ type: "spring", stiffness: 300, damping: 30 }}
          className="fixed bottom-0 left-0 right-0 z-40 bg-gradient-to-r from-blue-900 to-blue-800 text-white shadow-2xl border-t-4 border-amber-500"
        >
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
              {/* Left Content */}
              <motion.div
                initial={{ x: -50, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                transition={{ delay: 0.2 }}
                className="flex items-center space-x-4 flex-1 min-w-0"
              >
                <motion.div
                  animate={{ rotate: [0, 360] }}
                  transition={{ duration: 2, repeat: Infinity, ease: "linear" }}
                  className="hidden sm:flex items-center justify-center w-12 h-12 bg-amber-500 rounded-full shadow-lg flex-shrink-0"
                >
                  <i className="ri-percent-line text-2xl text-slate-900"></i>
                </motion.div>
                <div className="min-w-0 flex-1">
                  <div className="font-bold text-lg">Get Your Free DSCR Loan Quote</div>
                  <div className="text-sm text-blue-200">Rates from 6.5% • No income verification • Close in 21 days</div>
                </div>
              </motion.div>

              {/* Right CTA */}
              <motion.div
                initial={{ x: 50, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                transition={{ delay: 0.3 }}
                className="flex items-center gap-4 flex-shrink-0 ml-6"
              >
                <Link
                  to="/apply"
                  className="group px-6 py-3 bg-gradient-to-r from-amber-500 to-amber-600 text-slate-900 rounded-lg font-bold text-sm hover:from-amber-600 hover:to-amber-700 transition-all shadow-lg hover:shadow-amber-500/50 hover:scale-105 whitespace-nowrap text-center relative overflow-hidden flex-shrink-0"
                >
                  <span className="relative z-10 flex items-center justify-center">
                    <i className="ri-file-text-line mr-2"></i>
                    Apply Now
                    <motion.i
                      className="ri-arrow-right-line ml-1"
                      animate={{ x: [0, 5, 0] }}
                      transition={{ repeat: Infinity, duration: 1.5 }}
                    ></motion.i>
                  </span>
                </Link>
                <motion.button
                  whileHover={{ scale: 1.1, rotate: 90 }}
                  whileTap={{ scale: 0.9 }}
                  onClick={() => setIsVisible(false)}
                  className="p-2 hover:bg-white/10 rounded-lg transition-colors flex-shrink-0"
                  aria-label="Close"
                >
                  <i className="ri-close-line text-xl"></i>
                </motion.button>
              </motion.div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
